/* eslint-disable no-alert */
// require('asset/lib/anteater/util/anteater.validate.min.js');
import {
  tmpl, getQueryString, setVCode, verityInput,
} from '@/utils/util-extent';
// const DateSelector = require('../util/DateSelector.js');
import LocationViewer from '@/components/module/LocationViewer';
// const CarSelector = require('../calculator/CarSelector.js');
// const carSelector = new CarSelector(false);
import { isMobile } from '@/utils/device';
import moment from 'moment';

const { $, location } = window;

// const ONE_DAY = 1000 * 60 * 60 * 24;
// const ONE_HOUR = 1000 * 60 * 60;
const TIME_DATA = [
  {
    value: '',
    time: '-1',
    label: '請選擇時段',
  },
  {
    value: '0',
    time: '8',
    label: '08:00 ~ 10:00',
  },
  {
    value: '1',
    time: '10',
    label: '10:00 ~ 12:00',
  },
  {
    value: '2',
    time: '12',
    label: '12:00 ~ 14:00',
  },
  {
    value: '3',
    time: '14',
    label: '14:00 ~ 16:00',
  },
];
// 即刻預約試乘車種
const InstantCar = ['RAV4', 'COROLLA_CROSS', 'ALTIS', 'YARISCROSS'];

export default class TestDriveCore {
  constructor(opt = {}) {
    this.opt = $.extend({
      showMap: true,
      demoMode: false,
      cnyLimit: true,
    }, opt);
    this.$main = $('.main-wrapper');
    this.$groupDatetime = this.$main.find('#groupDatetime');
    this.loading = false;
    this.CRUrl = 'api/testdrive_sales.ashx';
    this.vaildUrl = 'api/testdrive_vaild.ashx';
    this.submitUrl = 'api/testdrive_submit.ashx';
    this.Url = 'api/testdrive_sales.ashx';
    this.getExcludeData();
    this.isInstant = false;
    this.instantUrl = 'api/testdrive_instantTime.ashx';
    this.carlist = [];
    this.userData = [];
    this.isLogin = false;
  }

  getExcludeData() {
    $.ajax({
      url: 'api/testdrive_expcars.ashx',
      type: 'GET',
      dataType: 'json',
      cache: 'false',
    })
      .done((e) => {
        if (e.RS === 'OK') {
          this.excludeData = e.DATA;
          TestDriveCore.setExcludeNoticeWords(e.NOTICE);
          this.ready();
        } else {
          console.log(e.RS);
        }
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        // console.log('complete');
      });
  }

  // todo
  static setExcludeNoticeWords(notice) {
    $('.testdrive-content .notice .exclude').html(notice);
  }

  ready() {
    const self = this;
    $.address.change(this.onAddressChange.bind(this));
    this.locationViewer = new LocationViewer('1', this.$main, {
      isScrollListByMarker: true,
      isListItemCheckable: true,
      showMap: this.opt.showMap,
    });

    TestDriveCore.initDateSel(this.getDisabledDates());

    this.updateVCode();

    this.initDateTime();
    this.initInstTime();

    // 是否需要業務事件
    this.$main.find('input[name=isCarOwner]').on('click', (e) => {
      const ishide = $(e.target).val() === 'false';
      if (ishide) {
        this.$main.find('#crRow').hide();
      } else {
        this.$main.find('#crRow').show();
      }
    });
    this.$main.find('#crRow').hide();

    // 引擎顯示並確認驗證
    this.$main.find('#testDriveCar').on('change', function change() {
      if ($(this).val() !== null && $(this).val() !== '') {
        location.replace(`${$.address.baseURL()}#/${$(this).val()}`);
        self.locationViewer.checkedItemData = null;
        // eng
        const $emgGroup = $('#carEngs');
        $emgGroup.show();
        const engs = $(this).find(':selected').data('eng').toString()
          .split(',');
        $emgGroup.find('.custom-radio').each((index, element) => {
          const value = $(element).find('input').val().toString();
          if (engs.indexOf(value) > -1) {
            $(element).show();
          } else {
            $(element).hide();
            $(element).find('input').get(0).setCustomValidity(''); // 隱藏則移除驗證
          }
        });
        $emgGroup.find('input').prop('checked', false);
        self.$main.find('input[name=careng]:visible').first().prop('checked', true);
      }
    });

    // 選擇服務項目
    this.$main.find('#serviceTestDrive').on('change', function change() {
      const carid = self.getSelectedCarId();
      // console.log(carid);
      if ($(this).prop('checked')) {
        // 是否為即刻試乘車種
        if (InstantCar.indexOf(carid) > -1) {
          self.isInstant = true;
          self.$main.find('#groupDatetime').hide();
          self.$main.find('#instantDatetime').show();
          if (!self.isLogin) {
            self.checkLogin();
          } else {
            $('#inputInstDate').trigger('change');
          }
        } else {
          self.isInstant = false;
          self.$main.find('#groupDatetime').show();
          self.$main.find('#instantDatetime').hide();
        }
      } else {
        self.initDateHide();
      }
    });

    // 選擇試乘據點
    $('#store-list').on('change', 'input[type=radio]', (e) => {
      if (self.isInstant) {
        // 即時試乘
        const instdata = {};
        let careng = '';
        if ($('input[name=careng]:checked').val() === '10') {
          careng = 'HYBRID';
        }
        const $obj = this.$main.find('#testDriveCar');
        const cartxt = $obj.find(':selected').text().toString();
        instdata.carname = `${cartxt} ${careng}`;
        instdata.qrydate = self.$main.find('#inputInstDate').val().replace(/-/g, '');
        instdata.dlrcd = $(e.target).val().substr(0, 1);
        instdata.brnhcd = $(e.target).val().substr(1, 2);
        instdata.dlrbrn = $(e.target).val();
        // console.log(instdata);
        this.getInstTimes(instdata);
      }
    });

    // 即時試乘-選擇期望試乘時間
    this.$main.find('#inputInstDate').on('change', (e) => {
      const itemData = self.locationViewer.checkedItemData;
      if (!itemData) {
        const chooseStoreElement = this.$main.find('[name="chooseStore"]');
        // 判斷據點清單是否存在
        if (chooseStoreElement.length) {
          this.$main.find('[name="chooseStore"]').get(0).setCustomValidity('請選擇試乘據點');
          this.$main.find('[name="chooseStore"]').get(0).reportValidity();
          console.log('請選擇試乘據點');
        } else {
          // search-filter-city
          this.$main.find('.search-filter-city select').get(0).setCustomValidity('請搜尋試乘或諮詢據點並選擇據點');
          this.$main.find('.search-filter-city select').get(0).reportValidity();
          console.log('請搜尋試乘或諮詢據點並選擇據點');
        }
        return;
      }
      this.$main.find('[name="chooseStore"]').get(0).setCustomValidity('');
      const loc = self.locationViewer.checkedItemData.key;
      if (self.isInstant) {
        const instdata = {};
        let careng = '';
        if ($('input[name=careng]:checked').val() === '10') {
          careng = 'HYBRID';
        }
        const $obj = this.$main.find('#testDriveCar');
        const cartxt = $obj.find(':selected').text().toString();
        instdata.carname = `${cartxt} ${careng}`;
        instdata.qrydate = $(e.target).val().replace(/-/g, '');
        instdata.dlrcd = loc.substr(0, 1);
        instdata.brnhcd = loc.substr(1, 2);
        instdata.dlrbrn = loc;
        console.log(instdata);
        this.getInstTimes(instdata);
      }
    });

    this.$main.find('#instantDatetime').hide();
    this.$main.find('#groupDatetime').hide();
    this.$main.find('#carEngs').hide();

    // this.$main.find('#crRow input, #crRow button').prop('disabled', true);

    this.$main.find('#crResult').hide();
    // 查詢業務
    this.$main.find('#recaptcha-query').on('click', this.onClickQuery.bind(this));
    this.$main.find('#recaptcha-reload').on('click', this.updateVCode.bind(this));
    // 送出
    this.$main.find('#testDriveForm').on('submit', this.onSubmit.bind(this));
    $('#vailForm #submitBtn').on('click', this.onVail.bind(this));
    // 請專人聯繫
    $('#errMsgContact').on('click', () => {
      self.isInstant = false;
      self.$main.find('#groupDatetime').show();
      self.$main.find('#instantDatetime').hide();
      $('#errMsgClose').trigger('click');
    });
    // 重新選擇
    $('#errMsgReselect').on('click', () => {
      self.isInstant = true;
      $('#errMsgClose').trigger('click');
    });


    if (this.opt.cnyLimit) TestDriveCore.showCNYLimitAlert();
    $.address.update();
    this.$main.find('#testDriveCar').trigger('change');
    // this.$main.find('#instantDatetime select').trigger('click');
    self.checkTDV();
    this.initVaild();

    // 輸入驗證碼跳位置
    $('.form-verification-code').keyup(function key() {
      if (this.value.length === this.maxLength) {
        $(this).next('input').focus();
      }
    });
  }

  static showCNYLimitAlert(delay = 500) {
    console.log(delay);
    // setTimeout(() => {
    //   alert('因應春節期間人員休假，目前暫不開放1/22~1/30的預約時段，如您於春節期間預約試乘，1/31起將有專人與您聯繫，確認預約事宜。造成不便敬請見諒。');
    // }, delay);
  }

  updateVCode(isSetFocus = false) {
    this.$main.find('#recaptcha').val('');
    setVCode(this.$main.find('#recaptcha-img'));
    if (isSetFocus) this.$main.find('#recaptcha').focus();
  }

  // 排除日期
  getDisabledDates() {
    if (this.opt.cnyLimit) {
      // 過年
      let tomorrow = new Date();
      const dates = [];
      for (let index = 0; index < 7; index += 1) {
        tomorrow = moment('2024-02-08').add(index, 'days');
        dates.push(tomorrow.format('YYYY-MM-DD'));
      }
      return dates;
    }
    return [];
  }

  static initDateSel(disabledDates) {
    const now = TestDriveCore.getNow();
    // 所有車款預約時間皆改為N+2；但如果下午6點後預約則是N+3。
    // EX: 11/15 10:00預約，提供11/17試乘選擇。11/15 18:00後預約，提供11/18試乘選擇。
    const maxHr = 18;
    const startDay = (now.getHours() < maxHr) ? 2 : 3;
    // 需判斷不在時間內 過年 2023/1/19 ~ 2023/1/30
    let minDate = moment().add(startDay, 'days');
    if (minDate.isBetween('2024-02-08', '2024-02-14')) {
      minDate = moment('2024-02-15');
    }
    const maxDate = moment().add(21, 'days');

    const dates = $('.js-test-drive-date');

    dates.each((index, el) => {
      $(el).val(minDate.format('YYYY-MM-DD'));

      $(el).datepicker({
        format: 'yyyy-mm-dd',
        weekStart: 0,
        startDate: minDate.format('YYYY-MM-DD'),
        endDate: maxDate.format('YYYY-MM-DD'),
        maxViewMode: 2,
        language: 'zh-TW',
        autoclose: true,
        defaultDate: new Date(),
        datesDisabled: disabledDates,
      })
        .on('show', (event) => {
          const target = $(event.currentTarget);
          target.addClass('focused');
        })
        .on('hide', (event) => {
          const target = $(event.currentTarget);
          target.removeClass('focused');
        });

      $(el).addClass('form-control-date');

      $(el).on('click', () => {
        $(el).datepicker('show');
      });
    });
  }

  initDateTime() {
    this.$groupDatetime.find('select').empty();
    for (let i = 0; i < TIME_DATA.length; i += 1) {
      const timeData = TIME_DATA[i];
      const tmplHtml = (timeData.value === '-1') ? '<option value="{{ VALUE }}" disabled selected>{{ LABEL }}</option>' : '"<option value="{{ VALUE }}">{{ LABEL }}</option>';
      const option = tmpl(tmplHtml, {
        VALUE: timeData.value,
        LABEL: timeData.label,
      });
      this.$groupDatetime.find('select').append(option);
    }
  }

  setCarType() {
    const carid = $.address.pathNames()[0];
    const $carType = this.$main.find('#testDriveCar');
    if (carid && carid !== '') {
      $carType.val(carid);
    }
  }

  getSelectedCarId() {
    const $carType = this.$main.find('#testDriveCar');
    if ($carType.val() !== '') {
      return $carType.val();
    }
    return $.address.pathNames()[0];
  }

  // 選車後篩據點 by MarkVann
  onAddressChange() {
    this.setCarType();
    const carid = this.getSelectedCarId();
    const [data] = this.excludeData.filter(({ id }) => (id === carid));
    if (!data) this.locationViewer.updateFilter();
    else if (data.city) this.locationViewer.excludeCities(data.city);
    else if (data.store) this.locationViewer.targetStores(data.store);
  }

  onSubmit(e) {
    if (e) e.preventDefault();

    // gaev('btn', 'click', 'btn_testdrive_ok');

    const data = {};
    const $serviceTestDrive = this.$main.find('#serviceTestDrive');
    const $serviceConsultation = this.$main.find('#serviceConsultation');
    if (!$serviceTestDrive.prop('checked') && !$serviceConsultation.prop('checked')) {
      if ($serviceTestDrive.prop('disabled')) {
        $serviceConsultation.get(0).setCustomValidity('請選擇服務項目');
        $serviceConsultation.get(0).reportValidity();
      } else {
        $serviceTestDrive.get(0).setCustomValidity('請選擇服務項目');
        $serviceTestDrive.get(0).reportValidity();
      }

      return;
    }
    $serviceTestDrive.get(0).setCustomValidity('');
    $serviceConsultation.get(0).setCustomValidity('');

    const choicServiceTestDrive = this.$main.find('#serviceTestDrive').prop('checked') ? this.$main.find('#serviceTestDrive').val() : 0;
    const choicServiceConsultation = this.$main.find('#serviceConsultation').prop('checked') ? this.$main.find('#serviceConsultation').val() : 0;
    data.TPY = Number.parseInt(choicServiceTestDrive, 10) + Number.parseInt(choicServiceConsultation, 10);

    data.CAR = this.getSelectedCarId();

    if (!TestDriveCore.vaildity(this.$main.find('#testDriveCar'), '請選擇試乘車款')) {
      console.log('請選擇試乘車款');
      return;
    }

    data.NAME = $('#inputName').val();

    if (!TestDriveCore.vaildity(this.$main.find('#inputName'), '請輸入中英文！', verityInput(data.NAME, 'htmltag') === false)) {
      console.log('請輸入中英文！');
      return;
    }

    if (this.$main.find('input[name=inputGender]:checked').length === 0) {
      this.$main.find('input[name=inputGender]').get(0).setCustomValidity('請選擇性別');
      this.$main.find('input[name=inputGender]').get(0).reportValidity();
      console.log('請選擇性別');
      return;
    }
    this.$main.find('input[name=inputGender]').get(0).setCustomValidity('');

    data.GENDER = $('input[name=inputGender]:checked').val();

    if (this.$main.find('input[name=careng]:checked').length === 0) {
      this.$main.find('input[name=careng]:visible').get(0).setCustomValidity('請選擇引擎');
      this.$main.find('input[name=careng]:visible').get(0).reportValidity();
      console.log('請選擇引擎');
      return;
    }
    this.$main.find('input[name=careng]').each((index, element) => {
      element.setCustomValidity('');
    });

    data.ENG = $('input[name=careng]:checked').val();
    data.ENGString = $(`label[for=${$('input[name=careng]:checked').attr('id')}]`).text();

    data.EMAIL = $('#inputEmail').val();

    if (!TestDriveCore.vaildity(this.$main.find('#inputEmail'), '無效的Email')) {
      console.log('無效的Email');
      return;
    }

    data.TEL = $('#inputPhone').val();

    if (!TestDriveCore.vaildity(this.$main.find('#inputPhone'), '請輸入完整電話！', verityInput(data.TEL, 'num') === false)) {
      console.log('請輸入電話');
      return;
    }

    if (this.$main.find('input[name=inputContactTime]:checked').length === 0) {
      this.$main.find('input[name=inputContactTime]').get(0).setCustomValidity('請選擇聯絡時間');
      this.$main.find('input[name=inputContactTime]').get(0).reportValidity();
      console.log('請選擇聯絡時間');
      return;
    }
    this.$main.find('input[name=inputContactTime]').get(0).setCustomValidity('');
    data.CONTACT_TIME = $('input[name=inputContactTime]:checked').val();
    console.log(`聯絡時間:${$('input[name=inputContactTime]:checked').val()}`);

    if (this.$main.find('#serviceTestDrive').prop('checked')) {
      let isVaildity = false;
      if (this.isInstant) {
        this.$main.find('#instantDatetime input').each((i, element) => {
          if (!TestDriveCore.vaildity($(element), '請選擇期望日期')) {
            isVaildity = true;
          }
        });
        this.$main.find('#instantDatetime select').each((i, element) => {
          if (!TestDriveCore.vaildity($(element), '請選擇期望時間')) {
            isVaildity = true;
          }
        });
        if (isVaildity) {
          console.log('請選擇期望時間');
          return;
        }
        data.isInstant = 'T';
        data.DATE = this.$main.find('#inputInstDate').val();
        data.TIME = this.$main.find('#selectInstTime').val();
        data.rsvstdt = $('#selectInstTime').find(':selected').data('cartime').toString();
        data.hdbrnhcd = $('#selectInstTime').find(':selected').data('branch').toString();
        data.rsvendt = $('#selectInstTime').find(':selected').data('endtime').toString();
        const filteredCarList = this.carlist.filter((car) => car.CARHDBRNHCD === data.hdbrnhcd);
        // console.log(filteredCarList);
        if (filteredCarList.length >= 1) {
          const carSel = filteredCarList[0];
          data.engno = carSel.CAREGNO;
          data.iseq = carSel.CARISEQ;
          data.cardlrcd = carSel.CARDLRCD;
        }
        // data.custid = this.userData.custid;
        // data.custName = this.userData.custName;
        // data.custMobile = this.userData.custMobile;
        // data.custsex = this.userData.custsex;
        // data.custemail = this.userData.custemail;
      } else {
        this.$main.find('#groupDatetime input').each((i, element) => {
          if (!TestDriveCore.vaildity($(element), '請選擇期望日期')) {
            isVaildity = true;
          }
        });
        this.$main.find('#groupDatetime select').each((i, element) => {
          if (!TestDriveCore.vaildity($(element), '請選擇期望時間')) {
            isVaildity = true;
          }
        });
        if (isVaildity) {
          console.log('請選擇期望時間');
          return;
        }
        data.isInstant = 'F';
        data.DATE = this.$main.find('#inputDate1').val();
        data.TIME = this.$main.find('#selectTime1').val();
        data.DATE2 = this.$main.find('#inputDate2').val();
        data.TIME2 = this.$main.find('#selectTime2').val();
        data.DATE3 = this.$main.find('#inputDate3').val();
        data.TIME3 = this.$main.find('#selectTime3').val();
      }
    }

    if (this.$main.find('[name="chooseStore"]').length === 0) {
      // search-filter-city
      this.$main.find('.search-filter-city select').get(0).setCustomValidity('請搜尋試乘或諮詢據點並選擇據點');
      this.$main.find('.search-filter-city select').get(0).reportValidity();
      console.log('請搜尋試乘或諮詢據點並選擇據點');
      return;
    }

    this.$main.find('.search-filter-city select').get(0).setCustomValidity('');
    data.checkedItemData = this.locationViewer.checkedItemData;
    if (!data.checkedItemData) {
      //
      this.$main.find('[name="chooseStore"]').get(0).setCustomValidity('請選擇試乘據點');
      this.$main.find('[name="chooseStore"]').get(0).reportValidity();
      console.log('請選擇試乘據點');
      return;
    }
    this.$main.find('[name="chooseStore"]').get(0).setCustomValidity('');

    data.LOC = data.checkedItemData.key;


    if (this.$main.find('input[name=useFormerSalesman]:checked').val() === true) {
      data.sales = this.$main.find('#dspresult').text();
    }

    if (!$('#agreeTerms').prop('checked')) {
      this.$main.find('[type="submit"]').get(0).setCustomValidity('請先閱讀並同意試乘條款');
      this.$main.find('[type="submit"]').get(0).reportValidity();
      console.log('請先閱讀並同意試乘條款');
      return;
    }

    if (!$('#agreePrivacy').prop('checked')) {
      this.$main.find('[type="submit"]').get(0).setCustomValidity('請先閱讀並同意TOYOTA官網隱私權條款');
      this.$main.find('[type="submit"]').get(0).reportValidity();
      console.log('請先閱讀並同意TOYOTA官網隱私權條款');
      return;
    }

    this.$main.find('[type="submit"]').get(0).setCustomValidity('');

    data.EDM = '0'; // $('#agreeTerms').prop('checked') ? '1' : '0';

    if (getQueryString('event')) {
      data.EVENT = getQueryString('event');
    }

    // 需簡訊驗證
    this.vail(data);
    $('#labPhone').text(data.TEL);
    // return false;
  }

  initVaild() {
    const self = this;
    this.$main.find('#serviceTestDrive,#serviceConsultation').on('change', () => {
      const $serviceTestDrive = this.$main.find('#serviceTestDrive');
      const $serviceConsultation = this.$main.find('#serviceConsultation');
      if (!$serviceTestDrive.prop('checked') && !$serviceConsultation.prop('checked')) {
        if ($serviceTestDrive.prop('disabled')) {
          $serviceConsultation.get(0).setCustomValidity('請選擇服務項目');
          $serviceConsultation.get(0).reportValidity();
        } else {
          $serviceTestDrive.get(0).setCustomValidity('請選擇服務項目');
          $serviceTestDrive.get(0).reportValidity();
        }
      } else {
        $serviceTestDrive.get(0).setCustomValidity('');
        $serviceConsultation.get(0).setCustomValidity('');
      }
    });

    this.$main.find('#testDriveCar').on('change', () => {
      // 利用延遲才有辦法產生效果
      setTimeout(() => {
        if (!TestDriveCore.vaildity(self.$main.find('#testDriveCar'), '請選擇試乘車款')) {
          console.log('請選擇試乘車款');
          return;
        }
        self.checkTDV();
      }, 500);
    });

    this.$main.find('input[name=careng]').on('change', function change() {
      $(this).get(0).setCustomValidity('');
    });

    this.$main.find('#inputName').on('change', function change() {
      TestDriveCore.vaildity($(this), '請輸入姓名');
    });

    this.$main.find('input[name=inputGender]').on('change', () => {
      this.$main.find('input[name=inputGender]').get(0).setCustomValidity('');
    });

    // inputContactTime
    this.$main.find('input[name=inputContactTime]').on('change', () => {
      this.$main.find('input[name=inputContactTime]').get(0).setCustomValidity('');
    });

    this.$main.find('#inputEmail').on('change', function change() {
      TestDriveCore.vaildity($(this), '無效的Email');
    });

    this.$main.find('#inputPhone').on('change', function change() {
      TestDriveCore.vaildity($(this), '請輸入電話');
    });

    this.$main.find('#groupDatetime input').on('change', function date() {
      TestDriveCore.vaildity($(this), '請選擇期望日期');
    });

    this.$main.find('#groupDatetime select').on('change', function time() {
      TestDriveCore.vaildity($(this), '請選擇期望時間');
    });

    this.locationViewer.on(LocationViewer.LIST_ITEM_CHECK, (data) => {
      if (!data) {
        this.$main.find('[name="chooseStore"]').get(0).setCustomValidity('請選擇試乘據點');
        this.$main.find('[name="chooseStore"]').get(0).reportValidity();
      } else {
        this.$main.find('[name="chooseStore"]').get(0).setCustomValidity('');
        this.$main.find('.search-filter-city select').get(0).setCustomValidity('');
      }
    });

    this.$main.find('#groupDatetime select').on('change', function time() {
      TestDriveCore.vaildity($(this), '請選擇期望時間');
    });

    this.$main.find('#instantDatetime select').on('change', function time() {
      TestDriveCore.vaildity($(this), '請選擇期望時間');
    });

    this.$main.find('#agreeTerms').on('change', (e) => {
      if (!$(e.target).prop('checked')) {
        this.$main.find('[type="submit"]').get(0).setCustomValidity('請先閱讀並同意試乘條款');
        this.$main.find('[type="submit"]').get(0).reportValidity();
      } else {
        this.$main.find('[type="submit"]').get(0).setCustomValidity('');
      }
    });

    this.$main.find('#agreePrivacy').on('change', (e) => {
      if (!$(e.target).prop('checked')) {
        this.$main.find('[type="submit"]').get(0).setCustomValidity('請先閱讀並同意TOYOTA官網隱私權條款');
        this.$main.find('[type="submit"]').get(0).reportValidity();
      } else {
        this.$main.find('[type="submit"]').get(0).setCustomValidity('');
      }
    });
  }

  vail(data) {
    if (this.loading) return;
    this.loading = true;
    $.ajax({
      url: this.vaildUrl,
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data,
    })
      .done((e) => {
        if (e.RS === 'OK') {
          this.submidata = data;
          $('[data-src="#test-drive-vaild"]').trigger('click');
          this.timeInterval();
        } else {
          alert(e.ERROR);
          if (e.LOGINURL !== '') window.location.replace(e.LOGINURL);
        }
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        // console.log('complete');
        this.loading = false;
      });
  }

  onVail(e) {
    if (e) e.preventDefault();
    let phoneCode = '';
    $('.form-verification-code').each((i, element) => {
      phoneCode += $(element).val().trim();
    });
    if (phoneCode.length < 4) {
      alert('請輸入驗證碼!');
      return;
    }
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.submidata.checkedItemData = `${this.submidata.checkedItemData.city + this.submidata.checkedItemData.area} - ${this.submidata.checkedItemData.title}`;
    this.submidata.phoneCode = phoneCode;
    if (this.isInstant) {
      this.addPostRsv(this.submidata);
    } else { this.submit(this.submidata); }
  }

  submit(data) {
    if (this.loading) return;
    this.loading = true;
    $.ajax({
      url: this.submitUrl,
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data,
    })
      .done((e) => {
        let eventLabel = '';
        if (e.RS === 'OK') {
          eventLabel = 'success';
        } else {
          eventLabel = 'failed';
        }
        if (window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: 'testdriveCar',
            event_car: data.CAR, // 車款名稱
            event_label: eventLabel, // 如預約成功填入'success'，預約失敗填入'failed'
            event_engine: data.ENGString, // 引擎類別
          });
        }
        if (e.RS === 'OK') {
          alert('預約成功');
          location.href = 'testdrive_search.aspx';
        } else {
          alert(e.RS);
        }
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        // console.log('complete');
        this.loading = false;
        $.fancybox.close();
        $('.form-verification-code').each((i, element) => {
          $(element).val('');
        });
      });
  }

  // ?
  static onSubmitComplete(data, rsDATA) {
    // gapv('testdrive_result.aspx#/{CAR}'.replace(/{CAR}/g, data.CAR));

    // dataLayer.push({'event': 'SubmitForm'});
    const $complete = $(tmpl(
      $('#template-testdrive-complete-content').html(),
      {
        NAME: data.NAME,
        CARID: data.CAR,
        TIME: `${data.DATE} ${data.timeStr}`,
        LOCATION: `${data.checkedItemData.city + data.checkedItemData.area} - ${data.checkedItemData.title}`,
      },
    ));
    $complete.find('a.addto-calender').attr({
      href: !isMobile() ? rsDATA.EVENT_LINK : rsDATA.EVENT_ICS,
      target: !isMobile() ? '_blank' : 'self',
      onclick: "gaev('btn', 'click', 'testdrive_add_btn');",
    });
    const carid = this.getSelectedCarId();
    switch (carid) {
      case 'PRIUS_PHV':
      default:
        $complete.find('a.limitedcar-couvailditypon').remove();
    }

    $('.page-content').empty().append($complete);
    window.TheModel.scrollTop(0, 100);
  }

  onClickQuery() {
    $.ajax({
      url: this.CRUrl,
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data: { LICSNO: `${$('#platFirst').val()}-${$('#platLast').val()}`, vcode: $('#recaptcha').val() },
    })
      .done((e) => {
        if (e.RS === 'OK') {
          $('#dspresult').text(e.DSPRESULT);
          $('#crResult').show();
        } else {
          this.$main.find('#recaptcha').get(0).setCustomValidity(e.RS);
          this.$main.find('#recaptcha').get(0).reportValidity();
          // setTimeout(() => {
          //   this.$main.find('#recaptcha').get(0).setCustomValidity('');
          // }, 1000);
        }
        this.updateVCode(true);
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        // console.log('complete');
      });
  }

  static vaildity($obj, message, isVaild = false) {
    if (!$obj || $obj.length === 0) {
      console.log('vaildity unfind !');
    } else if ($obj.get(0).value === '' || isVaild) {
      $obj.get(0).setCustomValidity(message);
      $obj.get(0).reportValidity();
    } else {
      $obj.get(0).setCustomValidity('');
      return true;
    }
    return false;
  }

  static getNow() {
    return new Date();
  }

  timeInterval() {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    const time = new Date();
    time.setMinutes(time.getMinutes() + 5);
    const endTime = time.getTime();
    this.timer = setInterval(() => {
      // 當前時間
      const nowTime = new Date().getTime();

      // 差值
      const offsetTime = (endTime - nowTime) / 1000; // ** 以秒為單位
      const min = parseInt((offsetTime / 60) % 60, 10); // 分
      const sec = parseInt(offsetTime % 60, 10); // 秒
      $('#viewTime').text(`${TestDriveCore.padLeft(min, 2)}:${TestDriveCore.padLeft(sec, 2)}`);
      if (min <= 0 && sec <= 0) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }, 200);
  }

  static padLeft(str, lenght) {
    if (str.toString().length >= lenght) {
      return str;
    }
    return TestDriveCore.padLeft(`0${str}`, lenght);
  }

  checkTDV() {
    const $obj = this.$main.find('#testDriveCar');
    if ($obj.val() === null) {
      return true;
    }
    const $tip = this.$main.find('#noneDrive');
    const $serviceTestDrive = this.$main.find('#serviceTestDrive');
    const tdv = $obj.find(':selected').data('istdv').toString();
    if (tdv === '0') {
      $tip.show();
      $serviceTestDrive.attr('disabled', true);
      $serviceTestDrive.prop('checked', false);
      this.initDateHide();
    } else {
      $tip.hide();
      $serviceTestDrive.attr('disabled', false);
      // 是否有勾選預約試乘
      if (this.$main.find('#serviceTestDrive').prop('checked')) {
      // 是否為即刻試乘車種
        if (InstantCar.indexOf($obj.val()) > -1) {
          this.isInstant = true;
          this.$main.find('#groupDatetime').hide();
          this.$main.find('#instantDatetime').show();
          if (!this.isLogin) {
            this.checkLogin();
          }
        } else {
          this.isInstant = false;
          this.$main.find('#groupDatetime').show();
          this.$main.find('#instantDatetime').hide();
        }
      } else {
        this.initDateHide();
      }
      return true;
    }
    return false;
  }

  initDateHide() {
    this.isInstant = false;
    this.$main.find('#groupDatetime').hide();
    this.$main.find('#instantDatetime').hide();
    this.$main.find('#groupDatetime input, #groupDatetime select').each((i, element) => {
      $(element).get(0).setCustomValidity('');
    });
    this.$main.find('#instantDatetime input, #instantDatetime select').each((i, element) => {
      $(element).get(0).setCustomValidity('');
    });
    this.initInstTime();
  }

  initInstTime() {
    this.$main.find('#instantDatetime').find('select').empty();
    const tmplHtml = '<option  data-cartime="{{ CARTIME }}" data-branch="{{ BRANCH }}"  data-endtime="{{ ENDTIME }}"  value="{{ VALUE }}" selected>{{ LABEL }}</option>';
    const option = tmpl(tmplHtml, {
      VALUE: '',
      LABEL: '請選擇時段',
      CARTIME: '',
      BRANCH: '',
      ENDTIME: '',
    });
    this.$main.find('#instantDatetime').find('select').append(option);
  }

  addInstTime(list) {
    list.forEach((timeData) => {
      const newHtml = `<option data-cartime="${timeData.CarTime}" data-branch="${timeData.Branch}" data-endtime="${timeData.UserETime}" value="${timeData.UserSTime}">${timeData.UserSTime}</option>`;
      this.$main.find('#instantDatetime').find('select').append(newHtml);
    });
  }

  getInstTimes(data) {
    $.ajax({
      url: this.instantUrl,
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data,
    })
      .done((e) => {
        if (e.RS === 'OK') {
          if (e.DATA.length >= 1) {
            const result = e.DATA[0];
            this.carlist = result.carList;
            this.initInstTime();
            this.addInstTime(result.timeList);
          }
        } else {
          // console.log(e.RS);
          this.initInstTime();
          $('#popup-errMsg').trigger('click');
          $('#errMsgTitle').text('目前暫無可預約時段');
          $('#errMsgResult').text('');
        }
      })
      .fail((e) => {
        console.log('error', e);
        this.initInstTime();
      })
      .always(() => {
        // console.log('complete');
      });
  }

  checkLogin() {
    $.ajax({
      url: 'api/testdrive_checkLogin.ashx',
      type: 'POST',
      dataType: 'json',
      cache: 'false',
    })
      .done((e) => {
        if (e.ReturnCode === '9999') {
          // console.log(e.ReturnCode);
          alert(`即時預約車款，${e.ReturnMsg}`);
          window.location.replace('/owner_login.aspx?xurl=testdrive.aspx');
        } else {
          console.log(e.ReturnCode);
          if (this.isInstant) {
            this.isLogin = true;
            this.userData = e.ReturnData;
            // console.log(this.userData);
          }
        }
      })
      .fail((e) => {
        console.log('error', e);
      });
  }

  addPostRsv(data) {
    $.ajax({
      url: 'api/testdrive_postRsv.ashx',
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data,
    })
      .done((e) => {
        if (e.RS === 'OK') {
          this.submidata = data;
          // console.log(e.DATA);
          if (e.DATA.isSuccess) {
            this.submidata.Webusrid = e.WEBUSRID;
            this.submidata.seqno = e.DATA.seqno;
            this.submit(this.submidata);
          } else {
            $.fancybox.close();
            $('.form-verification-code').each((i, element) => {
              $(element).val('');
            });
            $('#popup-errMsg').trigger('click');
            $('#errMsgTitle').text('預約失敗');
            $('#errMsgResult').text('該車款暫時無法即刻預約');
          }
        } else {
          console.log(e.WEBUSRID);
          $.fancybox.close();
          $('.form-verification-code').each((i, element) => {
            $(element).val('');
          });
          $('#popup-errMsg').trigger('click');
          $('#errMsgTitle').text('預約失敗');
          $('#errMsgResult').text(e.RS);
        }
      })
      .fail((e) => {
        console.log('error', e);
      });
  }
}
